import { DatePicker } from "@mui/x-date-pickers";


const CustomDatePicker = ({
    disabled = false,
    label,
    name,
    value,
    onChange,
    touched,
    errors,
    format = "dd/MM/yyyy",
    minDate,
    maxDate,
    size,
    variant = "filled",
    sx
}) => (
    <DatePicker
        disabled={disabled}
        label={label}
        value={value}
        format={format}
        minDate={minDate}
        maxDate={maxDate}
        onChange={(val) => onChange(name, val)}
        slotProps={{
            field: { clearable: !disabled },
            openPickerButton: { size: 'small', sx: { p: '2px' } },
            clearButton: { size: 'small', sx: { p: '2px' } },
            textField: {
                variant,
                fullWidth: true,
                size,
                error: !!touched?.[name] && !!errors?.[name],
                helperText: touched?.[name] && errors?.[name],
            },
        }}
        sx={sx}
    />
);

export default CustomDatePicker;
